<template>
	<div class="add-form">
		<Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
			<div class="tag-title">系统配置</div>
			<FormItem label="是否展示水印" prop="is_show">
				<RadioGroup v-model="form.is_show">
					<Radio label="1">开启</Radio>
					<Radio label="0">关闭</Radio>
				</RadioGroup>
			</FormItem>
			<FormItem v-if="form.is_show == 1" label="水印图" prop="watermark_image">
				<upload-file-one
					@on-success="uploadSuc($event)"
					:format="['png']"
					:defaultUrl="form.watermark_image"
					tips="* 请上传.png格式水印图，推荐大小：530 * 530"
				></upload-file-one>
			</FormItem>
		</Form>
		<Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
		<Button ghost type="primary" icon="ios-arrow-back" @click="$router.go(-1)">返回</Button>
	</div>
</template>

<script>
import { apiGetSystem, apiSetSystem } from '@/api/organization'
import uploadFileOne from '@/components/upload-custom/upload-file-one'

export default {
  name: 'add-form',
  components: {
    uploadFileOne
  },
  data () {
    return {
      query: {},
      search: {},
      diyDom: {},
      // 表单数据
      form: {
        is_show: '1',
        watermark_image: ''
      },
      diyData: {
        rules: {
          is_show: [
            {
              required: true,
              message: '请选择是否展示水印',
              trigger: 'blur'
            }
          ],
          watermark_image: [
            {
              required: true,
              message: '请上传水印图',
              trigger: 'change'
            }
          ]
        }
      },
      apiData: {}
    }
  },
  computed: {
    import_cert () {
      return process.env.VUE_APP_API_URL + '/upload/file'
    },
    headers () {
      return {
        authorization: localStorage.getItem('token')
      }
    }
  },
  methods: {
    // 获取配置
    getSettings () {
      this.$store.commit('setSpinShow', true)
      apiGetSystem(this.query.id, 'watermark')
        .then(res => {
          this.form = res
        })
        .finally(() => this.$store.commit('setSpinShow', false))
    },
    uploadSuc (e) {
      this.form.watermark_image = e.url
    },
    submit () {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          apiSetSystem(this.query.id, 'watermark', {
            watermark: this.form
          }).then(() => {
            this.$Message.success('保存成功')
            this.getSettings()
          })
        }
      })
    }
  },
  mounted () {
    this.query = this.$route.query
    this.getSettings()
  }
}
</script>

<style scoped lang="less">
	.add-form {
		border: 1px solid #ededed;
		margin: 0 20px;
		padding: 26px 20px;

		.title {
			font-size: 14px;
			font-weight: bold;
			color: #333333;
			line-height: 19px;
			margin-bottom: 10px;
		}
	}
</style>
